// Constants

export const COMPARISON_GROUP_COLORS = [
  "#6B7280",
  "#7C3AED",
  "#F59E0B",
  "#059669",
  "#DB2777",
];

export const statusConfig = {
  active: {
    value: "active",
    label: "Activo",
    class: "is-success is-light",
    icon: "play-circle",
  },
  paused: {
    value: "paused",
    label: "Pausado",
    class: "is-warning is-light",
    icon: "pause-circle",
  },
  completed: {
    value: "completed",
    label: "Completado",
    class: "is-info is-light",
    icon: "check-circle",
  },
  created: {
    value: "created",
    label: "Creado",
    class: "is-info",
    icon: "moon-new",
  },
};

export const surveyData = {
  groups: [
    [
      {
        id: "group-0",
        text: "Los valores que mejor describen cómo es esta organización son:",
        questions: [
          {
            id: "Cl_vl",
            label: "Clan",
            text: "colaboración, comunicación y desarrollo personal.",
          },
          {
            id: "Ad_vl",
            label: "Adhocrático",
            text: "innovación, agilidad y gestión de la incertidumbre.",
          },
          {
            id: "Je_vl",
            label: "Jerárquico",
            text: "consistencia, orden y seguridad.",
          },
          {
            id: "Me_vl",
            label: "Mercado",
            text:
              "reputación y orientación a resultados, orientación al cliente/usuario.",
          },
        ],
      },
      {
        id: "group-1",
        text: "La frase que mejor describe a esta organización es:",
        questions: [
          {
            id: "Me_cd",
            label: "Mercado",
            text:
              "somos orientados al cliente. Lo más importante para nosotros es cumplir las metas y satisfacer a los clientes/usuarios. ",
          },
          {
            id: "Je_cd",
            label: "Jerárquico",
            text:
              "somos métodicos y organizados. Lo más importante para nosotros es la calidad y el cumplimiento de los estándares.",
          },
          {
            id: "Cl_cd",
            label: "Clan",
            text:
              "somos una gran familia. Lo más importante son las personas y la forma como nos tratamos.",
          },
          {
            id: "Ad_cd",
            label: "Adhocrático",
            text:
              "somos innovadores. Lo más importante para nosotros es buscar soluciones novedosas para cada desafío.",
          },
        ],
      },
      {
        id: "group-2",
        text:
          "Las personas que son jefes en esta organización ponen en primer lugar:",
        questions: [
          {
            id: "Ad_lo",
            label: "Adhocrático",
            text: "la innovación, la agilidad y la toma de riesgos.",
          },
          {
            id: "Me_lo",
            label: "Mercado",
            text:
              "el cumplimiento de los objetivos, la rentabilidad y la orientación a los clientes/usuarios.",
          },
          {
            id: "Cl_lo",
            label: "Clan",
            text: "el buen trato, la colaboración y el crecimiento personal.",
          },
          {
            id: "Je_lo",
            label: "Jerárquico",
            text:
              "el cumplimiento de las reglas, la calidad y la seguridad en el trabajo.",
          },
        ],
      },
      {
        id: "group-3",
        text:
          "La forma en la cual la organización trabaja para conseguir sus objetivos es:",
        questions: [
          {
            id: "Ad_ee",
            label: "Adhocrático",
            text: "desarrollando soluciones innovadoras y asumiendo riesgos.",
          },
          {
            id: "Je_ee",
            label: "Jerárquico",
            text:
              "garantizando la calidad, la seguridad y haciendo seguimiento de los procesos.",
          },
          {
            id: "Cl_ee",
            label: "Clan",
            text:
              "cuidando a las personas que la integran y promoviendo su desarrollo.",
          },
          {
            id: "Me_ee",
            label: "Mercado",
            text:
              "satisfaciendo a los clientes/usuarios y consolidando la marca.",
          },
        ],
      },
      {
        id: "group-4",
        text: "En esta organización se considera que el mayor éxito es:",
        questions: [
          {
            id: "Cl_ce",
            label: "Clan",
            text:
              "el bienestar y crecimiento de las personas que la conforman.",
          },
          {
            id: "Me_ce",
            label: "Mercado",
            text:
              "el cumplimiento de las metas y la satisfacción del cliente. ",
          },
          {
            id: "Je_ce",
            label: "Jerárquico",
            text: "el trabajo realizado sin errores y con alta calidad.",
          },
          {
            id: "Ad_ce",
            label: "Adhocrático",
            text: "la innovación y la agilidad en lo que hacemos.",
          },
        ],
      },
      {
        id: "group-5",
        text: "Cuando en esta organización hay dificultades lo que hacemos es:",
        questions: [
          {
            id: "Ad_sp",
            label: "Adhocrático",
            text: "buscar alternativas creativas e ingeniosas.",
          },
          {
            id: "Je_sp",
            label: "Jerárquico",
            text: "establecer nuevos controles y procedimientos.",
          },
          {
            id: "Me_sp",
            label: "Mercado",
            text: "minimizar el impacto en el cliente y en la marca.",
          },
          {
            id: "Cl_sp",
            label: "Clan",
            text: "buscar soluciones conjuntas y fortalecer el equipo.",
          },
        ],
      },
    ],
    [
      {
        id: "group-0",
        text: "Los valores que mejor describen cómo es esta organización son:",
        questions: [
          {
            id: "Cl_vl",
            label: "Clan",
            text: "colaboración, comunicación y desarrollo personal.",
          },
          {
            id: "Ad_vl",
            label: "Adhocrático",
            text: "innovación, agilidad y gestión de la incertidumbre.",
          },
          {
            id: "Je_vl",
            label: "Jerárquico",
            text: "consistencia, orden y seguridad.",
          },
          {
            id: "Me_vl",
            label: "Mercado",
            text:
              "reputación y orientación a resultados, orientación al cliente/usuario.",
          },
        ],
      },
      {
        id: "group-1",
        text: "La frase que mejor describe a esta organización es:",
        questions: [
          {
            id: "Me_cd",
            label: "Mercado",
            text:
              "somos orientados al cliente. Lo más importante para nosotros es cumplir las metas y satisfacer a los clientes/usuarios. ",
          },
          {
            id: "Je_cd",
            label: "Jerárquico",
            text:
              "somos métodicos y organizados. Lo más importante para nosotros es la calidad y el cumplimiento de los estándares.",
          },
          {
            id: "Cl_cd",
            label: "Clan",
            text:
              "somos una gran familia. Lo más importante son las personas y la forma como nos tratamos.",
          },
          {
            id: "Ad_cd",
            label: "Adhocrático",
            text:
              "somos innovadores. Lo más importante para nosotros es buscar soluciones novedosas para cada desafío.",
          },
        ],
      },
      {
        id: "group-2",
        text:
          "Las personas que son jefes en esta organización ponen en primer lugar:",
        questions: [
          {
            id: "Ad_lo",
            label: "Adhocrático",
            text: "la innovación, la agilidad y la toma de riesgos.",
          },
          {
            id: "Me_lo",
            label: "Mercado",
            text:
              "el cumplimiento de los objetivos, la rentabilidad y la orientación a los clientes/usuarios.",
          },
          {
            id: "Cl_lo",
            label: "Clan",
            text: "el buen trato, la colaboración y el crecimiento personal.",
          },
          {
            id: "Je_lo",
            label: "Jerárquico",
            text:
              "el cumplimiento de las reglas, la calidad y la seguridad en el trabajo.",
          },
        ],
      },
      {
        id: "group-3",
        text:
          "La forma en la cual la organización trabaja para conseguir sus objetivos es:",
        questions: [
          {
            id: "Ad_ee",
            label: "Adhocrático",
            text: "desarrollando soluciones innovadoras y asumiendo riesgos.",
          },
          {
            id: "Je_ee",
            label: "Jerárquico",
            text:
              "garantizando la calidad, la seguridad y haciendo seguimiento de los procesos.",
          },
          {
            id: "Cl_ee",
            label: "Clan",
            text:
              "cuidando a las personas que la integran y promoviendo su desarrollo.",
          },
          {
            id: "Me_ee",
            label: "Mercado",
            text:
              "satisfaciendo a los clientes/usuarios y consolidando la marca.",
          },
        ],
      },
      {
        id: "group-4",
        text: "En esta organización se considera que el mayor éxito es:",
        questions: [
          {
            id: "Cl_ce",
            label: "Clan",
            text:
              "el bienestar y crecimiento de las personas que la conforman.",
          },
          {
            id: "Me_ce",
            label: "Mercado",
            text:
              "el cumplimiento de las metas y la satisfacción del cliente. ",
          },
          {
            id: "Je_ce",
            label: "Jerárquico",
            text: "el trabajo realizado sin errores y con alta calidad.",
          },
          {
            id: "Ad_ce",
            label: "Adhocrático",
            text: "la innovación y la agilidad en lo que hacemos.",
          },
        ],
      },
      {
        id: "group-5",
        text: "Cuando en esta organización hay dificultades lo que hacemos es:",
        questions: [
          {
            id: "Ad_sp",
            label: "Adhocrático",
            text: "buscar alternativas creativas e ingeniosas.",
          },
          {
            id: "Je_sp",
            label: "Jerárquico",
            text: "establecer nuevos controles y procedimientos.",
          },
          {
            id: "Me_sp",
            label: "Mercado",
            text: "minimizar el impacto en el cliente y en la marca.",
          },
          {
            id: "Cl_sp",
            label: "Clan",
            text: "buscar soluciones conjuntas y fortalecer el equipo.",
          },
        ],
      },
      // Cultura Deseada
      {
        id: "group-6",
        text:
          "Los valores que deberían describir cómo es esta organización son:",
        questions: [
          {
            id: "Cl_vl2",
            label: "Clan",
            text: "colaboración, comunicación y desarrollo personal.",
          },
          {
            id: "Ad_vl2",
            label: "Adhocrático",
            text: "innovación, agilidad y gestión de la incertidumbre.",
          },
          {
            id: "Je_vl2",
            label: "Jerárquico",
            text: "consistencia, orden y seguridad.",
          },
          {
            id: "Me_vl2",
            label: "Mercado",
            text:
              "reputación y orientación a resultados, orientación al cliente/usuario.",
          },
        ],
      },
      {
        id: "group-7",
        text: "La frase que mejor debería describir a esta organización es:",
        questions: [
          {
            id: "Me_cd2",
            label: "Mercado",
            text:
              "somos orientados al cliente. Lo más importante para nosotros es cumplir las metas y satisfacer a los clientes/usuarios. ",
          },
          {
            id: "Je_cd2",
            label: "Jerárquico",
            text:
              "somos métodicos y organizados. Lo más importante para nosotros es la calidad y el cumplimiento de los estándares.",
          },
          {
            id: "Cl_cd2",
            label: "Clan",
            text:
              "somos una gran familia. Lo más importante son las personas y la forma como nos tratamos.",
          },
          {
            id: "Ad_cd2",
            label: "Adhocrático",
            text: "somos innovadores. Lo más importante para nosotros es buscar soluciones novedosas para cada desafío.",
          },
        ],
      },
      {
        id: "group-8",
        text:
          "Las personas que son jefes en esta organización deberían poner en primer lugar:",
        questions: [
          {
            id: "Ad_lo2",
            label: "Adhocrático",
            text: "la innovación, la agilidad y la toma de riesgos.",
          },
          {
            id: "Me_lo2",
            label: "Mercado",
            text:
              "el cumplimiento de los objetivos, la rentabilidad y la orientación a los clientes/usuarios.",
          },
          {
            id: "Cl_lo2",
            label: "Clan",
            text: "el buen trato, la colaboración y el crecimiento personal.",
          },
          {
            id: "Je_lo2",
            label: "Jerárquico",
            text:
              "el cumplimiento de las reglas, la calidad y la seguridad en el trabajo.",
          },
        ],
      },
      {
        id: "group-9",
        text: "Para conseguir sus objetivos la organización debería:",
        questions: [
          {
            id: "Ad_ee2",
            label: "Adhocrático",
            text: "desarrollar soluciones innovadoras y asumir riesgos.",
          },
          {
            id: "Je_ee2",
            label: "Jerárquico",
            text:
              "garantizar la calidad, la seguridad y hacer seguimiento de los procesos.",
          },
          {
            id: "Cl_ee2",
            label: "Clan",
            text:
              "cuidar a las personas que la integran y promover su desarrollo.",
          },
          {
            id: "Me_ee2",
            label: "Mercado",
            text:
              "satisfacer a los clientes/usuarios y consolidar la marca.",
          },
        ],
      },
      {
        id: "group-10",
        text:
          "En esta organización se debería considerar que el mayor éxito es:",
        questions: [
          {
            id: "Cl_ce2",
            label: "Clan",
            text:
              "el bienestar y crecimiento de las personas que la conforman.",
          },
          {
            id: "Me_ce2",
            label: "Mercado",
            text:
              "el cumplimiento de las metas y la satisfacción del cliente. ",
          },
          {
            id: "Je_ce2",
            label: "Jerárquico",
            text: "el trabajo realizado sin errores y con alta calidad.",
          },
          {
            id: "Ad_ce2",
            label: "Adhocrático",
            text: "la innovación y la agilidad en lo que hacemos.",
          },
        ],
      },
      {
        id: "group-11",
        text:
          "Cuando en esta organización hay dificultades lo que deberíamos hacer es:",
        questions: [
          {
            id: "Ad_sp2",
            label: "Adhocrático",
            text: "buscar alternativas creativas e ingeniosas.",
          },
          {
            id: "Je_sp2",
            label: "Jerárquico",
            text: "establecer nuevos controles y procedimientos.",
          },
          {
            id: "Me_sp2",
            label: "Mercado",
            text: "minimizar el impacto en el cliente y en la marca.",
          },
          {
            id: "Cl_sp2",
            label: "Clan",
            text: "buscar soluciones conjuntas y fortalecer el equipo.",
          },
        ],
      },
    ],
  ],
  openEndedQuestions: [
    [
      {
        id: "openEnded-0",
        title: "Mi empresa hoy es...",
        text: `Piensa si alguien te pregunta ¿Cómo es hoy tu empresa? qué le responderías. A continuación, encontrarás cinco (5) campos de texto. Simplemente escribe las características que se te ocurran primero y que describan mejor a tu organización actualmente, hasta completar cinco (5) frases cortas.`,
        questions: [
          {
            id: "open-1",
            text: "Mi empresa es:",
            placeholder: "Describe en tus propias palabras...",
          },
          {
            id: "open-2",
            text: "Mi empresa es:",
            placeholder: "Describe en tus propias palabras...",
          },
          {
            id: "open-3",
            text: "Mi empresa es:",
            placeholder: "Describe en tus propias palabras...",
          },
          {
            id: "open-4",
            text: "Mi empresa es:",
            placeholder: "Describe en tus propias palabras...",
          },
          {
            id: "open-5",
            text: "Mi empresa es:",
            placeholder: "Describe en tus propias palabras...", // "Comparte tus ideas y sugerencias..."
          },
        ],
      },
    ],
    [
      {
        id: "openEnded-0",
        title: "Mi empresa hoy es...",
        text: `Piensa si alguien te pregunta ¿Cómo es hoy tu empresa? qué le responderías. A continuación, encontrarás cinco (5) campos de texto. Simplemente escribe las características que se te ocurran primero y que describan mejor a tu organización actualmente, hasta completar cinco (5) frases cortas.`,
        questions: [
          {
            id: "open-1",
            text: "Mi empresa es:",
            placeholder: "Describe en tus propias palabras...",
          },
          {
            id: "open-2",
            text: "Mi empresa es:",
            placeholder: "Describe en tus propias palabras...",
          },
          {
            id: "open-3",
            text: "Mi empresa es:",
            placeholder: "Describe en tus propias palabras...",
          },
          {
            id: "open-4",
            text: "Mi empresa es:",
            placeholder: "Describe en tus propias palabras...",
          },
          {
            id: "open-5",
            text: "Mi empresa es:",
            placeholder: "Describe en tus propias palabras...", // "Comparte tus ideas y sugerencias..."
          },
        ],
      },
      {
        id: "openEnded-1",
        title: "En el futuro mi empresa debería ser...",
        text: `Ahora piensa en el futuro. Las siguientes cinco (5) frases están dirigidas a describir cómo debería ser la empresa para ser exitosa (5 años). Si en este momento la empresa tiene características que se deben mantener, también pueden ser incluidas.`,
        questions: [
          {
            id: "open-1",
            text: "Mi empresa debería ser:",
            placeholder: "Describe en tus propias palabras...",
          },
          {
            id: "open-2",
            text: "Mi empresa debería ser:",
            placeholder: "Describe en tus propias palabras...",
          },
          {
            id: "open-3",
            text: "Mi empresa debería ser:",
            placeholder: "Describe en tus propias palabras...",
          },
          {
            id: "open-4",
            text: "Mi empresa debería ser:",
            placeholder: "Describe en tus propias palabras...",
          },
          {
            id: "open-5",
            text: "Mi empresa debería ser:",
            placeholder: "Describe en tus propias palabras...", // "Comparte tus ideas y sugerencias..."
          },
        ],
      },
    ],
  ],
};

// Functions
export function formatDate(dateString) {
  if (!dateString || !dateString.length) return "";
  const date = new Date(dateString);
  return date.toLocaleDateString("es-ES");
}
export function getStatusLabel(status) {
  const labels = Object.fromEntries(
    Object.entries(statusConfig).map(([key, value]) => [key, value.label]),
  );
  return labels[status] || status;
}
export function getStatusType(status) {
  const types = Object.fromEntries(
    Object.entries(statusConfig).map(([key, value]) => [key, value.class]),
  );
  return types[status] || "";
}
export function getStatusIcon(status) {
  const icons = Object.fromEntries(
    Object.entries(statusConfig).map(([key, value]) => [key, value.icon]),
  );
  return icons[status] || "circle";
}

export function hasPermission(permissions, keys) {
  if (!keys || !keys.length || !permissions) return false;

  if (permissions.admin) return true;

  return keys.some((key) => permissions[key] === true);
}

// functions por word cloud data preparation





function normalizeText(text) {
  return text
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // elimina tildes
    .replace(/[^a-zñ\s_]/g, " "); // elimina signos y números (conserva _ para frases compuestas)
}

function cleanAndTokenize(text) {
  if (!text) return [];
  const SYNONYMS = {
    // servicio / soporte
    servicios: "servicio",
    soporte: "servicio",
    atencion: "atencion",
    atender: "atencion",

    // experiencia
    experiencias: "experiencia",
    vivencia: "experiencia",

    // tiempo / velocidad
    rapido: "rapidez",
    rapida: "rapidez",
    lento: "demora",
    demoras: "demora",

    // comunicación
    comunicaciones: "comunicacion",
    informacion: "comunicacion",

    // plataforma / sistema
    sistema: "plataforma",
    herramienta: "plataforma",
    aplicacion: "plataforma",

    // personas
    empleados: "personal",
    colaboradores: "personal",
    equipo: "personal",

    // mejora / problema
    problemas: "problema",
    dificultades: "problema",
    mejoras: "mejora",

    // lugar (todo → mejor_sitio)
    // mejor_lugar: "mejor_sitio",
    // gran_lugar: "mejor_sitio",
    // buen_lugar: "mejor_sitio",

    // oportunidad (todo → oportunidades)
    oportunidad: "oportunidades",

    // responsabilidad (todo → responsable)
    responsabilidad: "responsable",

    // hogar (todo → segunda_casa)
    segundo_hogar: "segunda_casa",

    // liderazgo (todo → liderazgo)
    lider: "liderazgo",

    // región (todo → regional)
    region: "regional",

    // desarrollo (todo → desarrollarme)
    desarrollarse: "desarrollarme",
    desarrollo: "desarrollarme",
  };

  const STOPWORDS = new Set([
    "al",
    "algo",
    "asi",
    "aunque",
    "bien",
    "buen",
    "como",
    "compañias",
    "compañia",
    "condiciones",
    "con",
    "cosas",
    "cuando",
    "de",
    "debe",
    "del",
    "demas",
    "dia",
    "donde",
    "el",
    "empresa",
    "en",
    "entre",
    "era",
    "es",
    "ese",
    "estar",
    "esto",
    "fue",
    "gente",
    "gran",
    "ha",
    "haber",
    "han",
    "hay",
    "hasta",
    "la",
    "laboral",
    "las",
    "les",
    "lo",
    "los",
    "lugar",
    "mas",
    "me",
    "menos",
    "mi",
    "mis",
    "muchas",
    "mucho",
    "muchos",
    "muy",
    "nos",
    "o",
    "organizacion",
    "pais",
    "para",
    "parte",
    "pero",
    "personas",
    "poco",
    "por",
    "porque",
    "que",
    "se",
    "ser",
    "siendo",
    "sin",
    "sino",
    "solo",
    "son",
    "su",
    "sus",
    "tambien",
    "tanto",
    "te",
    "toda",
    "todas",
    "todos",
    "tu",
    "tus",
    "u",
    "una",
    "unas",
    "un",
    "unos",
    "y",
    "ya",
    "xrowsepx",
    "falta_xrowsepx",
  ]);

  return text
    .split(/\s+/)
    .map((word) =>
      SYNONYMS && SYNONYMS[word] !== undefined ? SYNONYMS[word] : word,
    )
    .filter((word) => word && word.length > 2 && !STOPWORDS.has(word));
}

function buildCorpus(responses) {
  // Sentinel between rows prevents findSpecialPhrases from matching phrases
  // that span two different responses.
  return (
    responses
      // .map(r => r.answers.join(" "))

      .join(" xrowsepx ")
  );
}

function findSpecialPhrases(text) {
  // Expects already-normalized text (lowercase, sin tildes, sin puntuación).
  let normalizedText = text;

  const PHRASES = [
    "calidad de vida",
    "mejor lugar",
    "gran lugar",
    "buen lugar",
    "segundo hogar",
    "segunda casa",
    "mejor sitio",
  ];

  // Reemplazar frases compuestas por versión con _
  PHRASES.forEach((phrase) => {
    const regex = new RegExp(`\\b${phrase}\\b`, "gi");
    const underscored = phrase.replace(/\s+/g, "_");
    normalizedText = normalizedText.replace(regex, underscored);
  });

  // Caso especial: "falta + siguiente palabra"
  normalizedText = normalizedText.replace(
    /\bfalta\s+([a-z0-9_]+)/gi,
    "falta_$1",
  );

  return normalizedText;
}

export function buildWordCloudData(responses) {
  const corpus = buildCorpus(responses);
  // Orden: 1) normalizar (lowercase, sin tildes, sin puntuación)
  //        2) unir frases compuestas con _  (antes de stopwords)
  //        3) tokenizar: split + synonyms + stopwords
  const normalized = normalizeText(corpus);
  const withPhrases = findSpecialPhrases(normalized);
  const tokens = cleanAndTokenize(withPhrases);

  const frequency = {};

  tokens.forEach((word) => {
    frequency[word] = (frequency[word] || 0) + 1;
  });

  // elimina palabras demasiado frecuentes (poco informativas)
  const maxAllowed = responses.length * 0.8;
  return Object.entries(frequency)
    .filter(([, value]) => value <= maxAllowed)
    .map(([text, value]) => ({ text, value }))
    .sort((a, b) => b.value - a.value);
}



// WEBPACK FOOTER //
// ./src/components/cultura/helpers.js